import { ContactDocumentTypeMessages } from "@/messages/contacts/contact-document-type.messages";
import { ContactPersonTypeMessages } from "@/messages/contacts/contact-person-type.messages";
import { DocumentType, PersonType } from "@/types/document.types";

export const CONTACT_PERSON_TYPE_TRANSLATION = (
  messages: ContactPersonTypeMessages
): Record<PersonType, string> => {
  return {
    [PersonType.Individual]: messages.individualOption,
    [PersonType.LegalEntity]: messages.corporateOption,
  };
};

export const CONTACT_DOCUMENT_TYPE_TRANSLATION = (
  messages: ContactDocumentTypeMessages
): Record<DocumentType, string> => {
  return {
    [DocumentType.RG]: messages.rgOption,
    [DocumentType.CPF]: messages.cpfOption,
    [DocumentType.CNPJ]: messages.cnpjOption,
    [DocumentType.UNDEFINED]: "",
  };
};

export enum ConsentStatus {
  CANCELED = "canceled",
  COMPLETED = "completed",
  NOT_COMPLETED = "not_completed",
}
